export default __webpack_public_path__ + "static/tek_img_12-8fe6af72152a034a412bfcc3ef6da876.webp";